module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insight-item"
  }, [_c('div', {
    staticClass: "unit-head"
  }, [_c('el-popover', {
    attrs: {
      "content": _vm.description,
      "width": "250",
      "placement": "bottom-end",
      "trigger": "hover"
    }
  }, [_c('h5', {
    staticClass: "unit-title",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("Reactions")])])], 1), _vm._v(" "), (_vm.reaction && _vm.reaction.total) ? _c('div', _vm._l((_vm.reactionsMap), function(cfg, key) {
    return _c('span', {
      key: key
    }, [(_vm.reaction[key]) ? _c('el-tooltip', {
      attrs: {
        "content": key
      }
    }, [_c('el-badge', {
      staticClass: "reaction",
      attrs: {
        "value": _vm.reaction[key] || 0
      }
    }, [_c('emoji', {
      staticClass: "emoji-icon",
      attrs: {
        "emoji": cfg.emoji,
        "set": _vm.emojiSet,
        "size": _vm.size
      }
    })], 1)], 1) : _vm._e()], 1)
  }), 0) : _c('div', {
    staticClass: "no-reactions"
  }, [_vm._v("None")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6f88c9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/facebook/PostReactions.vue
// module id = 3384
// module chunks = 3